import React, { useEffect } from "react";
import { ImageAttachmentData } from "~/models/card";
import { fetchImageData } from "~/common/api/image";

/**
 * retrieve the image url and data for a given image id and size from REST API
 * this used to use useSelect, but moved it to the REST API to support both
 * widgets and blocks without needing to duplicate the logic in both places
 *
 * @param imageId
 * @param size
 * @returns {imageAttributes: {src: string, alt: string} | undefined}
 */
export const useImageAttachment = (
  imageId: number | undefined,
  size: string,
) => {
  const [image, setImage] = React.useState<ImageAttachmentData | undefined>();

  useEffect(() => {
    const fetchImage = async (imageId: number) => {
      const imageData = await fetchImageData(imageId);
      if (imageData && imageData[size]) {
        setImage({
          src: imageData[size].url,
          alt: imageData[size].alt,
        });
      } else {
        setImage(undefined);
      }
    };

    // go get the image data for the current image id if we have one
    if (imageId) {
      fetchImage(imageId);
    }
  }, [imageId, size]);

  return image;
};
